import { AxiosAdapter } from 'axios'
import LRUCache from 'lru-cache'
import buildSortedURL, { genParams } from './buildSortedURL'
import { lxMV } from '../../lx'
import { CustomRequestConfig } from '../types'

function isCacheLike(cache: LRUCache<string, any>) {
  return !!(
    cache.set &&
    cache.get &&
    cache.del &&
    typeof cache.get === 'function' &&
    typeof cache.set === 'function' &&
    typeof cache.del === 'function'
  )
}

const FIVE_MINUTES = 1000 * 60 * 5
const CAPACITY = 100

export default function cacheAdapterEnhancer(
  adapter: AxiosAdapter,
  options?: {
    enabledByDefault?: boolean
    cacheFlag?: string
    defaultCache?: LRUCache<string, any>
  },
): AxiosAdapter {
  const {
    enabledByDefault = false,
    cacheFlag = 'cache',
    defaultCache = new LRUCache({ maxAge: FIVE_MINUTES, max: CAPACITY }),
  } = options || {}

  return (config: CustomRequestConfig) => {
    const { url = '', params, data, paramsSerializer, forceUpdate } = config
    /* eslint-disable no-void */
    const useCache = config[cacheFlag] !== void 0 && config[cacheFlag] !== null ? config[cacheFlag] : enabledByDefault
    if (useCache) {
      // if had provide a specified cache, then use it instead
      const cache = isCacheLike(useCache) ? useCache : defaultCache
      // build the index according to the url and params
      const index = buildSortedURL(url, genParams(data, params), paramsSerializer)
      let responsePromise = cache.get(index)
      if (!responsePromise || forceUpdate) {
        responsePromise = (async () => {
          try {
            return await adapter(config)
          } catch (reason) {
            cache.del(index)
            throw reason
          }
        })()
        cache.set(index, responsePromise)
        return responsePromise
      }
      lxMV('b_airbnb_7kmg9gsm_mv', {
        custom: {
          title: index,
        },
      })
      return responsePromise
    }

    return adapter(config)
  }
}
